import React, { useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { exportManufacturerThunk, getAllManufacturersThunk, setManufacturerPage, setManufacturerRefresh } from '../../../redux/manufacturer/getAllManufacturerSlice';
import api from '../../../utils/api';
import { toast } from 'react-toastify';
import MasterHeader from '../../../component/reusable/MasterHeader';
import { exportDataExcel, fomateDate } from '../../../utils/fomateDate';
import ManufacturersTable from '../../../component/manufacturerComps/ManufacturersTable';



const Manufacturers = () => {

  const { manufacturer, loading, error, refresh, exportLoading,page } = useSelector((state) => state.manufacturer);
  const [search, setSearch] = useState('')
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const [statuss, setStatus] = useState("");
  // const [page, setPage] = useState(1)
  const [limit, setLimit] = useState(25)
  const [sortBy, setSortyBy] = useState('name');
  const [order, setOrder] = useState('asc')

  const manufacturers = manufacturer?.data
  const totalPages = manufacturer?.totalPages
  const totalItems = manufacturer?.totalItems
  const itemsPerPage = manufacturer?.limit

  // calculate start & end of items -------------------
  const start = (page - 1) * limit + 1;
  const end =
    totalPages === page
      ? totalItems
      : (page - 1) * limit + limit;


  useEffect(() => {
    dispatch(setManufacturerPage(1));
  }, [search, statuss, dispatch]);

  useEffect(() => {
    dispatch(getAllManufacturersThunk(`?search=${search}&page=${page}&status=${statuss}&limit=${limit}&sortBy=${sortBy}&order=${order}`));
  }, [page, search, statuss, limit, refresh,sortBy,order]);


  const handleFileChange = async (e) => {
    try {
      const file = e.target.files[0];
      if (!file) return;

      const formData = new FormData();
      formData.append('file', file);

      const response = await api.bulkUploadManufacturer(formData);
      if (response.data) {
        console.log(response.data);
        toast.success(response?.data?.data?.message)
        dispatch(setManufacturerRefresh());
      }
    } catch (err) {
      console.log(err);
      toast.error(err?.response?.data?.message || 'Something went wrong')
    }
  };


  const exportData = async () => {
    const data = await dispatch(exportManufacturerThunk())

    if (data?.payload?.success === true) {
      const manufacturerdata = data?.payload?.data
      const exportdata = manufacturerdata?.map((item) => ({
        'name': item?.name || '-',
        'description': item?.description,
        'productCount': item?.productCount || 0,
        'cover_image': item?.cover_image?.map(i => i)?.join(', ') || '-',
        'thumbnail_photo': item?.thumbnail?.photo?.map(i => i)?.join(', ') || '-',
        'thumbnail_status': item?.thumbnail?.status,
        'createdAt': fomateDate(item?.createdAt),
      }))
      exportDataExcel(exportdata, "manufacturer")
    }
  }


  const handleOpenMenu = (sort) => {
    setSortyBy(sort)
    setOrder((prevOrder) => (prevOrder === 'asc' ? 'desc' : 'asc'));
  };
  return (
    <div>

      <MasterHeader
        index="Manufacturers"
        root="Dashboard"
        setStatus={setStatus}
        setSearch={setSearch}
        handleFileChange={handleFileChange}
        onClickadd={() => navigate('/master/addManufacturer')}
        buttonText={'Add new Manufacturers'}
        exportData={exportData}
        exportLoading={exportLoading}
      />
      {loading ?
        <div>
          Please wait...
        </div>
        :
        <>
          {
            manufacturers?.length > 0 ?
              <ManufacturersTable
                Manufacturer={manufacturers}
                itemsPerPage={itemsPerPage}
                start={start}
                end={end}
                setPage={setManufacturerPage}
                totalItems={totalItems}
                page={page}
                handleOpenMenu={handleOpenMenu}
              />
              :
              <div>
                No manufacturer found
              </div>

          }
        </>
      }
    </div>
  );
};

export default Manufacturers;
